import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "impx-menu-cat-group-wrapper" }
const _hoisted_2 = { class: "impx-menu-page-group impx-menu-page-3col" }
const _hoisted_3 = { class: "uk-grid uk-grid-medium uk-margin-medium-bottom impx-margin-bottom" }
const _hoisted_4 = { class: "uk-width-2-3@xl uk-width-2-3@l uk-width-2-3@m uk-width-4-5@s impx-menu-page-group-title" }
const _hoisted_5 = { class: "uk-margin-remove" }
const _hoisted_6 = { class: "uk-width-1-3@xl uk-width-1-3@l uk-width-1-3@m uk-width-1-5@s uk-container-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "impx-menu-page menu-list" }
const _hoisted_9 = { class: "impx-menu-page-item" }
const _hoisted_10 = { class: "impx-menu-page-content" }
const _hoisted_11 = { class: "impx-menu-page-price" }



export default /*@__PURE__*/_defineComponent({
  __name: 'MenuBlocItem',
  props: {
  title:String,
  desc:String,
  menuList:[],
  imgDesc:String

},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "impx-menu-cat-group-outline" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(props.title), 1),
          _createElementVNode("p", null, _toDisplayString(props.desc), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: props.imgDesc,
            alt: "Menu Resto",
            class: "uk-border-circle uk-align-center"
          }, null, 8, _hoisted_7)
        ])
      ]),
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.menuList, (menu, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h5", null, _toDisplayString(menu.title), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h5", null, _toDisplayString(menu.price) + " CFA", 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(menu.subtitle), 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})